function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-364 -252)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(364 252)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.137,44.274A22.137,22.137,0,1,0,0,22.137,22.2,22.2,0,0,0,22.137,44.274Z",
  transform: "translate(4.427 4.427)",
  fill: "none",
  stroke: "#936f33",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0V11.069",
  transform: "translate(26.564 17.71)",
  fill: "none",
  stroke: "#936f33",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H.02",
  transform: "translate(26.552 35.419)",
  fill: "none",
  stroke: "#936f33",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H53.129V53.129H0Z",
  fill: "none",
  opacity: 0
})));

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.129,
    height: 53.129,
    viewBox: "0 0 53.129 53.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.94667aa4.svg";
export { ForwardRef as ReactComponent };